import { IDataQ4, ISummaryQ4 } from '../../../../../../modules/API/Reports/models/q4'
import { isValid, parse } from 'date-fns'
import { formatRange } from '../../../../../../generic/ui/DatePicker/formatRange'
import { Q2DateRange, Q2FieldKey, Q2Row, Q2SummaryValues } from '../types/row'

export const Q2_FIELD_KEYS: Q2FieldKey[] = [
  'Field1',
  'Field2',
  'Field3',
  'Field4',
  'Field5',
  'Field6',
  'Field7',
]

const EMPTY_SUMMARY: Q2SummaryValues = {
  dateRange: '',
  amountPack: '0',
  middlePrice: '0.00',
  amountPallets: '0',
  weight: '0.00',
}

// Desc wins; an empty desc falls back to the raw id (same rule as the Excel export).
const toLabel = (item: IDataQ4, key: Q2FieldKey): string =>
  item[`${key}_Desc`]?.trim() || String(item[key])

// yyyyMMdd → Date; an empty or malformed value yields null so formatRange never sees an Invalid Date.
const parseYmd = (value: string): Date | null => {
  const date = parse(value, 'yyyyMMdd', new Date())
  return isValid(date) ? date : null
}

export const toQ2Rows = (data: IDataQ4[]): Q2Row[] =>
  data.map((item, index) => {
    const labels = Object.fromEntries(
      Q2_FIELD_KEYS.map((key) => [`${key}_Label`, toLabel(item, key)]),
    ) as Pick<Q2Row, `${Q2FieldKey}_Label`>

    return {
      ...item,
      ...labels,
      rowId: index,
      PricePerKg: item.Price && item.Weight ? item.Price / item.Weight : null,
    }
  })

export const formatQ2Summary = (
  summary: ISummaryQ4 | null,
  range: Q2DateRange | null,
): Q2SummaryValues => ({
  dateRange: range ? formatRange(parseYmd(range.from), parseYmd(range.to)) : '',
  amountPack: summary ? summary.AmountPack.toLocaleString() : EMPTY_SUMMARY.amountPack,
  middlePrice: summary ? summary.MiddlePrice.toFixed(2) : EMPTY_SUMMARY.middlePrice,
  amountPallets: summary ? summary.AmountPallets.toLocaleString() : EMPTY_SUMMARY.amountPallets,
  weight: summary ? summary.Weight.toLocaleString() : EMPTY_SUMMARY.weight,
})
